import smooth from 'smooth-polyline';
import { transform } from 'ol/proj.js';
import { createPolygon } from '@ro-utils/common/map/newPolygons';

import { LAYER_SKYPREDICT } from '@ro-utils/constant';

const description = {
  '1': {
    label: 'burza',
    short_description: {
      '1': 'deszcz 15-40 mm I/LUB wiatr 60-90 km/h I/LUB grad <2 cm',
      '2': 'deszcz 41-70 mm I/LUB wiatr 91-110 km/h I/LUB grad 2-5cm ',
      '3': 'deszcz >70 mm I/LUB wiatr > 110 km/h I/LUB grad >5 cm '
    },
    description: {
      '1':
        '[PAMI\u0118TAJ!:] W czasie burzy nale\u017cy zachowa\u0107 szczeg\u00f3ln\u0105 ostro\u017cno\u015b\u0107 - nie nale\u017cy wychodzi\u0107 na zewn\u0105trz budynk\u00f3w. Je\u015bli burza zaskoczy w otwartym terenie, nale\u017cy unika\u0107 drzew oraz wszelkich wy\u017cszych konstrukcji, w kt\u00f3re m\u00f3g\u0142by trafi\u0107 piorun. Burze mog\u0105 powodowa\u0107 lokalne szkody - zalewa\u0107 piwnice, \u0142ama\u0107 ga\u0142\u0119zie drzew, powodowa\u0107 utrudnienia komunikacyjne i przerwy w dostawach energii elektrycznej. ',
      '2':
        '[PAMI\u0118TAJ!:] W czasie burzy nale\u017cy zachowa\u0107 szczeg\u00f3ln\u0105 ostro\u017cno\u015b\u0107 - nie nale\u017cy wychodzi\u0107 na zewn\u0105trz budynk\u00f3w. Je\u015bli burza zaskoczy w otwartym terenie, nale\u017cy unika\u0107 drzew oraz wszelkich wy\u017cszych konstrukcji, w kt\u00f3re m\u00f3g\u0142by trafi\u0107 piorun lub mog\u0142yby zosta\u0107 przewr\u00f3cone przez silne porywy wiatru. Radzimy na bie\u017c\u0105co obserwowa\u0107 sytuacj\u0119 meteorologiczn\u0105 w kraju, tzn. s\u0142ucha\u0107 komunikat\u00f3w w radiu i telewizji, ogl\u0105da\u0107 bie\u017c\u0105ce ostrze\u017cenia przygotowane przez meteorolog\u00f3w, \u015bledzi\u0107 dane radarowe, obserwowa\u0107 aktualn\u0105 pogod\u0119 w miejscu przebywania. Burze mog\u0105 powodowa\u0107 lokalne szkody - powodowa\u0107 lokalnie podtopienia i zalania, uszkadza\u0107 budynki, \u0142ama\u0107 i wyrywa\u0107 z korzeniami drzewa, niszczy\u0107 uprawy, powodowa\u0107 utrudnienia komunikacyjne i przerwy w dostawach energii elektrycznej. Istnieje zagro\u017cenie dla zdrowia i \u017cycia. ',
      '3':
        'TO JEST SZCZEG\u00d3LNIE GRO\u0179NA SYTUACJA... [PAMI\u0118TAJ!:] W czasie burzy nale\u017cy zachowa\u0107 szczeg\u00f3ln\u0105 ostro\u017cno\u015b\u0107 - nie nale\u017cy wychodzi\u0107 na zewn\u0105trz budynk\u00f3w. Je\u015bli burza zaskoczy w otwartym terenie, nale\u017cy unika\u0107 drzew oraz wszelkich wy\u017cszych konstrukcji, w kt\u00f3re m\u00f3g\u0142by trafi\u0107 piorun lub mog\u0142yby zosta\u0107 przewr\u00f3cone przez silne porywy wiatru. Radzimy na bie\u017c\u0105co obserwowa\u0107 sytuacj\u0119 meteorologiczn\u0105 w kraju i by\u0107 gotowym na wyj\u0105tkowo siln\u0105 burz\u0119, tzn. s\u0142ucha\u0107 komunikat\u00f3w w radiu i telewizji, ogl\u0105da\u0107 bie\u017c\u0105ce ostrze\u017cenia przygotowane przez meteorolog\u00f3w, \u015bledzi\u0107 dane radarowe, obserwowa\u0107 aktualn\u0105 pogod\u0119 w miejscu przebywania, s\u0142ucha\u0107 komunikat\u00f3w og\u0142aszanych przez lokalne s\u0142u\u017cby zarz\u0105dzania kryzysowego, przygotowa\u0107 bezpieczne schronienie do kt\u00f3rego nale\u017cy si\u0119 uda\u0107 podczas nawa\u0142nicy (w przypadku dom\u00f3w jednorodzinnych lub kilkurodzinnych najlepiej piwnic\u0119 lub pomieszczenie bez okien, w \u015brodku budynku). Nale\u017cy mie\u0107 ze sob\u0105 radio na baterie, kt\u00f3re umo\u017cliwi s\u0142uchanie bie\u017c\u0105cych komunikat\u00f3w o pogodzie. Burze mog\u0105 powodowa\u0107 znacz\u0105ce szkody - powodowa\u0107 lokalnie podtopienia i zalania, powodzie b\u0142yskawiczne, uszkadza\u0107 i niszczy\u0107 budynki, \u0142ama\u0107 i wyrywa\u0107 z korzeniami drzewa, niszczy\u0107 uprawy, powodowa\u0107 powa\u017cne utrudnienia komunikacyjne i przerwy w dostawach energii elektrycznej. Istnieje du\u017ce zagro\u017cenie dla zdrowia i \u017cycia'
    },
    color: {
      '1': '#fc66e4',
      '2': '#fc32b4',
      '3': '#a4028c'
    },
    icon: {
      '1': 'lightning',
      '2': 'lightning',
      '3': 'hurricane'
    }
  },
  '2': {
    label: 'deszcz',
    short_description: {
      '1': 'deszcz 15-40 mm I/LUB \u015bnieg 10-15 cm',
      '2': 'deszcz 41-70 mm I/LUB \u015bnieg 16-30 cm',
      '3': 'deszcz >70 mm I/LUB \u015bnieg >30 cm'
    },
    color: {
      '1': '#9496fc',
      '2': '#4c4afc',
      '3': '#0402a4'
    },
    icon: {
      '1': 'rain',
      '2': 'rain',
      '3': 'rain'
    }
  },
  '3': {
    label: 'wiatr',
    short_description: {
      '1': '71-90 km/h',
      '2': '91-110 km/h',
      '3': '>110 km/h'
    },
    color: {
      '1': '#94fe94',
      '2': '#4cca4c',
      '3': '#047a04'
    },
    icon: {
      '1': 'small-craft-advisory',
      '2': 'gale-warning',
      '3': 'hurricane-warning'
    }
  },
  '4': {
    label: 'upa\u0142',
    short_description: {
      '1': '30-34\u00b0C',
      '2': '35-38\u00b0C ',
      '3': '>38\u00b0C'
    },
    color: {
      '1': '#fcbe6c',
      '2': '#fca234',
      '3': '#fc6a04'
    },
    icon: {
      '1': 'hot',
      '2': 'hot',
      '3': 'hot'
    }
  },
  '5': {
    label: 'mr\u00f3z',
    short_description: {
      '1': '-25 do -20\u00b0C',
      '2': '-26 do -30\u00b0C',
      '3': '<-30\u00b0C'
    },
    color: {
      '1': '#fcf2fc',
      '2': '#bca6bc',
      '3': '#7c6e7c'
    },
    icon: {
      '1': 'snowflake-cold',
      '2': 'snowflake-cold',
      '3': 'snowflake-cold'
    }
  },
  '6': {
    label: 'tr\u0105ba powietrzna',
    short_description: {
      '1': 'ryzyko niewielkie',
      '2': 'ryzyko umiarkowane',
      '3': 'ryzyko wysokie'
    },
    description: {
      '1':
        '[PAMI\u0118TAJ!:] Ostrze\u017cenie pierwszego stopnia przed tr\u0105bami powietrznymi oznacza, \u017ce w regionie i w jego pobli\u017cu s\u0105 niewielkie szanse na uformowanie si\u0119 s\u0142abej lub umiarkowanej tr\u0105by powietrznej. Nie wychod\u017a na otwart\u0105 przestrze\u0144 w czasie burzy, na bie\u017c\u0105co sprawdzaj sytuacj\u0119 meteorologiczn\u0105 i obserwuj niebo. Gdy zobaczysz obni\u017caj\u0105c\u0105 si\u0119, wiruj\u0105c\u0105 chmur\u0119 b\u0105d\u017a wiruj\u0105cy lej kondensacyjny i chmur\u0119 unoszonych szcz\u0105tk\u00f3w, natychmiast przejd\u017a do piwnicy lub pomieszczenia bez okien, w \u015brodku budynku. Tr\u0105ba powietrzna mo\u017ce spowodowa\u0107 lokalne zniszczenia w budynkach, drzewostanie, w liniach energetycznych i telefonicznych, powodowa\u0107 powa\u017cne utrudnienia komunikacyjne i sprowadzi\u0107 bezpo\u015brednie zagro\u017cenie dla zdrowia i \u017cycia.',
      '2':
        '[PAMI\u0118TAJ!:] Ostrze\u017cenie drugiego stopnia przed tr\u0105bami powietrznymi oznacza, \u017ce w regionie i w jego pobli\u017cu s\u0105 du\u017ce szanse na uformowanie si\u0119 tr\u0105by powietrznej. Nie wychod\u017a na otwart\u0105 przestrze\u0144 w czasie burzy, na bie\u017c\u0105co sprawdzaj sytuacj\u0119 meteorologiczn\u0105, sprawdzaj komunikaty w mediach i obserwuj niebo. Gdy zobaczysz obni\u017caj\u0105c\u0105 si\u0119, wiruj\u0105c\u0105 chmur\u0119 b\u0105d\u017a wiruj\u0105cy lej kondensacyjny i chmur\u0119 unosz\u0105cych si\u0119 szcz\u0105tk\u00f3w, natychmiast przejd\u017a do piwnicy lub pomieszczenia bez okien, w \u015brodku budynku. Tr\u0105ba powietrzna mo\u017ce spowodowa\u0107 lokalne zniszczenia w budynkach, drzewostanie, w liniach energetycznych i telefonicznych, powodowa\u0107 powa\u017cne utrudnienia komunikacyjne. Istnieje zagro\u017cenie dla zdrowia i \u017cycia. ',
      '3':
        'TO JEST SZCZEG\u00d3LNIE GRO\u0179NA SYTUACJA... [PAMI\u0118TAJ!:] Ostrze\u017cenie trzeciego stopnia przed tr\u0105bami powietrznymi oznacza, \u017ce w regionie i w jego pobli\u017cu jest bardzo du\u017ce zagro\u017cenie tr\u0105b\u0105 powietrzn\u0105 o destruktywnej sile. Trzeci stopie\u0144 ostrze\u017cenia przed tr\u0105bami powietrznymi oznacza, \u017ce tr\u0105by powietrzne by\u0142y prawdopodobnie ju\u017c notowane i nale\u017cy ich si\u0119 dalej spodziewa\u0107 z powodu bardzo korzystnych dla tych zjawisk warunk\u00f3w pogodowych. Nie wychod\u017a na otwart\u0105 przestrze\u0144 w czasie burzy, na bie\u017c\u0105co sprawdzaj sytuacj\u0119 meteorologiczn\u0105, sprawdzaj komunikaty w mediach i obserwuj niebo. Gdy zobaczysz obni\u017caj\u0105c\u0105 si\u0119, wiruj\u0105c\u0105 chmur\u0119 b\u0105d\u017a wiruj\u0105cy lej kondensacyjny i chmur\u0119 unosz\u0105cych si\u0119 szcz\u0105tk\u00f3w, natychmiast przejd\u017a do piwnicy lub pomieszczenia bez okien, w \u015brodku budynku. Tr\u0105ba powietrzna mo\u017ce spowodowa\u0107 lokalne zniszczenia w budynkach, drzewostanie, w liniach energetycznych i telefonicznych, powodowa\u0107 powa\u017cne utrudnienia komunikacyjne. Istnieje du\u017ce zagro\u017cenie dla zdrowia i \u017cycia.'
    },
    color: {
      '1': '#fc4a4c',
      '2': '#cc2e2c',
      '3': '#7c0204'
    },
    icon: {
      '1': 'tornado',
      '2': 'tornado',
      '3': 'tornado'
    }
  }
};

export const makeSkyPredictMap = function(data, map, settings) {
  const skyPredictData = data;
  const skyPredictDescription = description;
  const features = [];
  let optionals;
  skyPredictData &&
    skyPredictData.forEach(function(el, i) {
      const type = skyPredictDescription[el.type];
      const path = [];
      const param = name => type[name] && type[name][el.level];
      const makeSmooth = (path, numIterations) => {
        numIterations = Math.min(Math.max(numIterations, 1), 10);
        while (numIterations > 0) {
          path = smooth(path);
          numIterations--;
        }
        return path;
      };
      el.points.forEach(function(point) {
        path.push(transform([point.lat, point.lon], 'EPSG:4326', 'EPSG:3857'));
      });
      const smoothenedPath = makeSmooth(path, 3);
      optionals = {
        desc: param('description'),
        shortDesc: param('short_description'),
        validFrom: el.validFrom,
        validTo: el.validTo,
        priority: el.level,
        identify: type['label'] + '_' + el.level,
        UIType: LAYER_SKYPREDICT,
        roUIID: `${LAYER_SKYPREDICT}_${el.type}`,
        color: param('color'),
        icon: param('icon'),
        title: type['label'],
        source: 'lowcyburz.pl',
        link: 'http://lowcyburz.pl'
      };

      const polygonConfig = {
        UIType: LAYER_SKYPREDICT,
        path: smoothenedPath,
        frame: true,
        opacityFill: parseInt(settings.opacityFill, 10) / 100,
        opacityStroke: parseInt(settings.opacityStroke, 10) / 100,
        color: param('color'),
        strokeWidth: 1,
        optional_params: optionals,
        zIndex: el.level,
        layerIndex: settings.index
      };
      features.push(polygonConfig);
    });
  createPolygon(features, map, LAYER_SKYPREDICT, optionals);
};
